import { getCookie, setCookie } from "../../js/Util";

$('.js-header-banner').each(function(i, rootDom) {
    const isShown = getCookie('header-banner-shown');

    if (!isShown) {
        $(rootDom).addClass('_visible');
    }

    $('.js-header-banner-close', rootDom).on('click', function() {
        setCookie('header-banner-shown', true);
        $(rootDom).removeClass('_visible');
    });
});
